import { FormHelperText, Stack, StackProps, styled } from '@mui/material';

import { Editable } from 'slate-react';

import { hexToRgba } from '../../utils/color';
import { generateClasses } from '../../utils/helper';

export const richTextEditorClasses = generateClasses('richTextEditor', ['body', 'error', 'editable']);

export const Root = styled((props: StackProps) => <Stack gap={1} {...props} />)(({ theme }) => ({
  border: `0.5px solid ${theme.palette.grey[300]}`,
  borderRadius: 8,
  overflow: 'hidden',
  [`& .${richTextEditorClasses.body}`]: {
    flex: 1,
    overflow: 'auto',
  },
}));

export const Body = styled(Stack)(({ theme }) => ({
  backgroundColor: hexToRgba(theme.palette.primary[500], 0.05),
  color: theme.palette.common.black,
  padding: theme.spacing(2),
  borderBottom: `0.5px solid ${theme.palette.grey[300]}`,

  [`&.${richTextEditorClasses.error}`]: {
    backgroundColor: theme.palette.error[50],
    borderColor: theme.palette.error[600],
  },

  [`& .${richTextEditorClasses.editable}`]: {
    flex: 1,
  },
}));

export const StyledEditable = styled(Editable)(() => ({
  // height: '100%',
  '& [data-slate-placeholder="true"]': {
    display: 'inline-block !important',
  },
}));

export const Error = styled(FormHelperText)(({ theme }) => ({
  color: theme.palette.error[600],
}));
